import React from "react";
import { Box, BoxProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const Offset: React.FC<BoxProps> = ({ sx, ...rest }) => {
  const theme = useTheme();

  return (
    <Box
      component="div"
      sx={{
        ...theme.mixins.toolbar,
        ...sx
      }}
      {...rest}
    />
  );
};
